import BaseRequest from './BaseRequest';

const schema = 'user/white-list';
/**
 * key base on host:port
 */
export default class WhiteListRequest extends BaseRequest {
  /**
	 * @param params
	 * @returns {Promise<*|undefined>}
	 */
  fetchWhiteListAddress(params) {
    const url = `${schema}/all`;
    return this.get(url, params);
  }

  /**
	 * @param params
	 * @returns {Promise<*|undefined>}
	 */
  deleteWhiteListAddress(params) {
    const url = `${schema}/`;
    return this.del(url, params);
  }

  /**
	 * @param params
	 * @returns {Promise<*|undefined>}
	 */
  addAddressToWhiteList(params) {
    const url = `${schema}/`;
    return this.post(url, params);
  }

  /**
	 * @param params
	 * @returns {Promise<*|undefined>}
	 */
  updateWhiteListAddress(params) {
    const url = `${schema}/`;
    return this.put(url, params);
  }
}
